import {
  PraksisaktivitetStatusDto,
  PraksiskalenderAktivitetDto,
} from '../api/generated/praksissted-generated-api';

export const practicePeriodColorClass = (
  period: PraksiskalenderAktivitetDto | null,
): string => {
  if (!period || !period.status) {
    return '';
  }
  switch (period.status) {
    case PraksisaktivitetStatusDto.KanBekreftes:
      return 'ready-to-share';
    case PraksisaktivitetStatusDto.BekreftetOgHarKapasitet:
      return 'shared-filled-capacity';
    case PraksisaktivitetStatusDto.BekreftetMenManglerKapasitet:
      return 'shared-missing-capacity';
    case PraksisaktivitetStatusDto.BekreftetMenManglerFordeling:
      return 'student-assignment-warning';
    case PraksisaktivitetStatusDto.BekreftetOverstyrtKapasitet:
      return 'shared-filled-capacity';
    case PraksisaktivitetStatusDto.KlarForGjennomfoering:
      return 'ready-to-start';
    case PraksisaktivitetStatusDto.Gjennomfoert:
      return 'published-finished';
    case PraksisaktivitetStatusDto.Avtalefeil:
      return 'agreementWarning';
  }
};

export enum ActivityStatusOptions {
  UNFILTERED = 'unfiltered',
  ALL_ACTIVITIES = 'allActivities',
  ACTIVITIES_NOT_SHARED = 'activitiesNotShared',
  ACTIVITIES_MISSING_CAPACITY = 'activitiesMissingCapacity',
  ACTIVITIES_FILLED_CAPACITY = 'activitiesFilledCapacity',
}
